<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="标题">
      <t-input size="small" v-model="attribute.title" :maxcharacter="52"/>
    </t-form-item>
    <t-form-item label="标题颜色">
      <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.titleColor"/>
    </t-form-item>
    <t-form-item label="标题字体">
      <t-input-number size="small" v-model="attribute.titleSize" :min="4" :max="200" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="数值字体">
      <t-input-number size="small" v-model="attribute.numSize" :min="4" :max="200" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="数值格式化">
      <t-input size="small" v-model="attribute.format"/>
    </t-form-item>
    <t-form-item label="南丁格尔图">
      <t-select size="small" v-model="attribute.roseType">
        <t-option label="不展示" value="false"/>
        <t-option label="圆心角" value="radius"/>
        <t-option label="扇区" value="area"/>
      </t-select>
    </t-form-item>
    <t-form-item label="进度粗细">
      <t-slider size="small" v-model="attribute.progressWidth" :min="0" :max="80" :decimal-places="0"/>
    </t-form-item>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-icon-ring-option",
  components: {CptData},
  props: { attribute: Object,cptDataForm:Object,},
}
</script>

<style scoped>

</style>
